import React from 'react';

interface WcfSettings {
    SendTimeout?: string;
    ReceiveTimeout?: string;
    OpenTimeout?: string;
    CloseTimeout?: string;
}

interface MerlionSupplierConfigurationProps {
    configuration: {
        WcfSettings?: string;
        AttributesSyncIntervalHours?: number;
    };
    onChange: (field: string, value: string | number | unknown) => void;
    disabled?: boolean;
}

interface MerlionConfigurationComponent extends React.FC<MerlionSupplierConfigurationProps> {
    configFields: string[];
}

const MerlionConfiguration: MerlionConfigurationComponent = ({
    configuration,
    onChange,
    disabled = false
}) => {
    const handleAttributesSyncIntervalChange = (value: string) => {
        const parsedValue = Number(value);
        onChange('AttributesSyncIntervalHours', Number.isFinite(parsedValue) && parsedValue > 0 ? parsedValue : 24);
    };

    const handleWcfSettingsChange = (wcfField: string, value: string) => {
        const currentWcfSettings = configuration.WcfSettings || {};
        const updatedWcfSettings = {
            ...currentWcfSettings,
            [wcfField]: value
        };
        onChange('WcfSettings', updatedWcfSettings);
    };

    const parseWcfSettings = (): WcfSettings => {
        if (!configuration.WcfSettings) return {};
        if (typeof configuration.WcfSettings === 'string') {
            try {
                return JSON.parse(configuration.WcfSettings);
            } catch {
                return {};
            }
        }
        return configuration.WcfSettings;
    };

    const wcfSettings = parseWcfSettings();

    return (
        <React.Fragment>
            <div style={{ gridColumn: '1 / -1' }}>
                <label className="form-label-custom">
                    <span className="label-icon">⚙️</span>
                    Настройки WCF
                </label>
            </div>

            <div className="form-group-custom">
                <label className="form-label-custom">Интервал обновления атрибутов, часов</label>
                <div className="input-group-custom">
                    <input
                        type="number"
                        className="form-input-custom"
                        value={configuration.AttributesSyncIntervalHours ?? 24}
                        onChange={(e) => handleAttributesSyncIntervalChange(e.target.value)}
                        min="1"
                        step="1"
                        disabled={disabled}
                    />
                </div>
            </div>

            <div className="form-group-custom">
                <label className="form-label-custom">Send Timeout</label>
                <div className="input-group-custom">
                    <input
                        type="text"
                        className="form-input-custom"
                        value={wcfSettings.SendTimeout || '00:05:00'}
                        onChange={(e) => handleWcfSettingsChange('SendTimeout', e.target.value)}
                        placeholder="00:05:00"
                        disabled={disabled}
                    />
                </div>
            </div>

            <div className="form-group-custom">
                <label className="form-label-custom">Receive Timeout</label>
                <div className="input-group-custom">
                    <input
                        type="text"
                        className="form-input-custom"
                        value={wcfSettings.ReceiveTimeout || '00:10:00'}
                        onChange={(e) => handleWcfSettingsChange('ReceiveTimeout', e.target.value)}
                        placeholder="00:10:00"
                        disabled={disabled}
                    />
                </div>
            </div>

            <div className="form-group-custom">
                <label className="form-label-custom">Open Timeout</label>
                <div className="input-group-custom">
                    <input
                        type="text"
                        className="form-input-custom"
                        value={wcfSettings.OpenTimeout || '00:01:00'}
                        onChange={(e) => handleWcfSettingsChange('OpenTimeout', e.target.value)}
                        placeholder="00:01:00"
                        disabled={disabled}
                    />
                </div>
            </div>

            <div className="form-group-custom">
                <label className="form-label-custom">Close Timeout</label>
                <div className="input-group-custom">
                    <input
                        type="text"
                        className="form-input-custom"
                        value={wcfSettings.CloseTimeout || '00:01:00'}
                        onChange={(e) => handleWcfSettingsChange('CloseTimeout', e.target.value)}
                        placeholder="00:01:00"
                        disabled={disabled}
                    />
                </div>
            </div>
        </React.Fragment>
    );
};

// Define the configuration fields used by this supplier
MerlionConfiguration.configFields = ['WcfSettings', 'AttributesSyncIntervalHours'];

export default MerlionConfiguration;
